import { render } from "./CenterParcel.vue?vue&type=template&id=1f0aec61"
import script from "./CenterParcel.vue?vue&type=script&lang=js"
export * from "./CenterParcel.vue?vue&type=script&lang=js"

import "./CenterParcel.vue?vue&type=style&index=0&id=1f0aec61&lang=css"

import exportComponent from "/workspace/goj/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__